import styled, { keyframes } from "styled-components";

export const DivMain = styled.div`
    display: ${(props) => props.mostrar ?? "none"};
    top: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000000c2;
`;

export const Container = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 200px;
`;

const animation = keyframes`
    0% {
      stroke-dasharray: 1 98;
      stroke-dashoffset: -105;
    }
    50% {
      stroke-dasharray: 80 10;
      stroke-dashoffset: -160;
    }
    100% {
      stroke-dasharray: 1 98;
      stroke-dashoffset: -300;
    }
  `;

export const Spinner = styled.circle`
    transform-origin: center;
    animation-name: ${animation};
    animation-duration: 1.2s;
    animation-timing-function: cubic-bezier;
    animation-iteration-count: infinite;
    fill: transparent;
    stroke: #24a1dd;
    stroke-width: 7px;
    stroke-linecap: round;
`;
